<template>
  <q-tr
    :props="props"
    class="odd:bg-neutral-2 cursor-pointer !h-48"
    @click="emit('click', grupoArquivo?.nome)"
  >
    <q-td key="status" class="">
      <OBadge
        :text="status.label"
        :style="{ background: status.cor }"
      />
    </q-td>

    <q-td key="fabricante" class="">
      {{ row.fabricante?.nome }}
    </q-td>

    <q-td key="regiao" class="">
      {{ row.nome_regiao }}
    </q-td>

    <q-td key="grupo_arquivo__nome" class="">
      {{ grupoArquivo?.nome }}
    </q-td>

    <q-td key="data_abertura" class="">
      {{ FData(row.data_abertura) }}
    </q-td>

    <q-td key="data_fechamento" class="">
      {{ FData(row.data_fechamento) }}
    </q-td>

    <q-td key="template" class="">
      <OButton
        class="!h-32 !py-0 !bg-neutral-100/5"
        secondary
        size="sm"
        :label="t('btn.template')"
        icon-size="1.5rem"
        icon="download"
        :href="row.template"
        target="_blank"
        @click.stop="$emit('click:template', grupoArquivo?.nome)"
      />
    </q-td>

    <q-td key="user" class="">
      <OAvatar
        v-if="row.usuario_serializado?.nome"
        :nome="row.usuario_serializado?.nome"
      />
      <p v-else class="text-neutral-60">
        -
      </p>
    </q-td>

    <q-td key="observacoes" class="">
      <p class="one-line">
        {{ row.observacoes || '-' }}
      </p>
    </q-td>

    <q-td key="anexar" class="">
      <OButton
        class="!h-32 !py-0"
        :label="t('btn.attach')"
        tertiary
        size="sm"
        icon="upload"
        @click.stop="$emit('click:anexar', grupoArquivo?.nome)"
      />
    </q-td>
  </q-tr>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { grupoArquivosService } from 'services/grupoArquivos.service'
import { gruposArquivos } from 'store/arquivo.store'
import { useI18n } from 'vue-i18n'
import { userService } from 'services/users.service'
import GLOBAL from 'js/utils/GLOBAL'
import OAvatar from 'components/Avatar/OAvatar.vue'
import OBadge from 'components/Badge/OBadge.vue'
import OButton from 'components/Button/OButton.vue'

const { t } = useI18n()

const { props } = defineProps({
  props: {
    type: Object,
    required: true,
  },
})
const emit = defineEmits(['click:anexar', 'click:template', 'click'])
const { FData } = GLOBAL
const { row } = props
const { getGrupoArquivo } = grupoArquivosService()

const { getUser } = userService()
const grupoArquivo = ref(null)

const users = ref([])

const status = computed(() => {
  return (
    {
      pendente: { cor: 'rgba(247, 153, 0, 0.10)', label: 'Pendente' },
      indisponivel: {
        cor: 'rgba(27, 29, 38, 0.10)',
        label: 'Indisponível',
      },
      aprovado: {
        cor: 'rgba(31, 153, 104, 0.10))',
        label: 'Aprovado',
      },
      em_revisao: {
        cor: 'rgba(23, 165, 197, 0.10)',
        label: 'Em Revisão',
      },
      reprovado: { cor: 'rgba(212, 2, 3, 0.10)', label: 'Reprovado' },
    }[row.status] || {}
  )
})

onMounted(() => {
  const _grupo = gruposArquivos.value.find(
    ({ id }) => id === row.grupo_arquivo.id
  )
  if (_grupo) grupoArquivo.value = _grupo
  else
    getGrupoArquivo(row.grupo_arquivo.id) //
      .then((v) => {
        grupoArquivo.value = v
        const arr = [...gruposArquivos.value, v]
        gruposArquivos.value = arr.filter(GLOBAL.unique)
        // console.log('gruposArquivos', gruposArquivos.value);
      })
})
</script>

<style lang="scss" scoped></style>
